import {Component, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import steps from './free-steps.json';
import proSteps from './platform-steps.json';
import {ActivatedRoute, Router} from "@angular/router";
import {ProductService} from "../../../product.service";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Subject} from "rxjs";
import {Config} from "../../../../../config/config";
import {animate, style, transition, trigger} from "@angular/animations";
import {UserSubscription} from "../../../../../user/user-subscription";

interface IStep {
  title: string;
  desc: string;
}

@Component({
    selector: 'db-booster-plugin-download-dialog',
    templateUrl: './booster-plugin-download-dialog.component.html',
    styleUrls: ['./booster-plugin-download-dialog.component.scss'],
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: 'translateX(20px)', opacity: 0 }),
                animate('200ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1, position: 'absolute' }),
                animate('200ms ease-in', style({ transform: 'translateX(-60px)', opacity: 0, position: 'absolute' }))
            ])
        ]),
        trigger('scale', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms ease-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1, position: 'absolute', right: 0 }),
                animate('200ms ease-in', style({ opacity: 0, position: 'absolute', right: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class BoosterPluginDownloadDialogComponent implements OnInit {

  public boosterSteps: IStep[];
  public isMobile: boolean;
  public loading: boolean;
  public userSubscription: UserSubscription;
  public boosterService: string[] = [
    '90+ PageSpeed score', 'Improved Core Web Vitals', 'Cloudflare Enterprise', 'Full page caching'
  ];

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _activeModal: DbActiveModal,
    private _router: Router,
    private _route: ActivatedRoute,
    private _productService: ProductService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.getUser();
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public getUser(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        filter((user: UserSubscription) => !!user),
        takeUntil(this._destroyStream$)
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
        this.boosterSteps = this.userSubscription.paidClient ? proSteps : steps;
      });
  }

  public downloadBoosterPlugin(): void {
    window.location.href = Config.boosterAutoConnectVersion;
  }
}
